// extracted by mini-css-extract-plugin
module.exports = {"outlet":"OutletAccordion_outlet__gtnsf","heading":"OutletAccordion_heading__SgBJ4","accordionTitle":"OutletAccordion_accordionTitle__3P3w9"};